import './table.scss'


import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import {getLanguage} from 'react-multi-lang'
import { Box, Typography } from '@mui/material';
import { havePermission } from '../../services/hoc/permissions';
import PermissionBox from '../no-permission/box';
interface Column {
  id: 'name' | 'code' | 'population' | 'size' | 'density';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'name', label: 'Name', minWidth: 170 },
  { id: 'code', label: 'ISO\u00a0Code', minWidth: 100 },
  {
    id: 'population',
    label: 'Population',
    minWidth: 170,
    align: 'right',
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'size',
    label: 'Size\u00a0(km\u00b2)',
    minWidth: 170,
    align: 'right',
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'density',
    label: 'Density',
    minWidth: 170,
    align: 'right',
    format: (value: number) => value.toFixed(2),
  },
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

interface iProps {
    rows:any,
    headers:string[],
    maxHeight?:string,
    label:string,
    permission_key:string
}

export default function StickyHeadTable({rows,headers,maxHeight,label,permission_key}:iProps) {


  return (
    <Paper sx={{ width: '100%', overflow:{xs:'scroll',sm:'hidden'} ,border:'none',boxShadow:'none',
  //  paddingRight:getLanguage()==='en'? '30px':'0',
  //  paddingLeft:getLanguage()==='en'? '0':'30px',
   marginBottom:' 5px'
   ,maxHeight:maxHeight?maxHeight:'undefined',
      
             
  
  }
   
  }
   className='sticky-table'
   
   >
    <Box sx={{
      width:'100%',
      display:'flex'
    }}>

    <Typography variant='h5' sx={{color:'var(--primary-color)',fontSize:{lg:'1.5rem',xs:'1rem'}}}>
      {label}
    </Typography>
    </Box>
      <TableContainer sx={{ maxHeight: {lg:maxHeight?'100%':'40%',sm:'100%'},paddingBottom:'1rem' }}>
        <PermissionBox 
        permission_key={permission_key}>
        <Table stickyHeader aria-label="sticky table"
      
        sx={{
          width: '100%',
          textAlign: 'left',
         borderCollapse: 'unset',
        borderSpacing: '0 10px',
          position: 'relative'
          ,paddingBottom:'2rem'
        }}>
          <TableHead>
            <TableRow sx={{
              lg:{
                lineHeight: '30px',
               minHeight: '50px'
            }
           
            }
            }>
              {headers.map((head,index) => (
                <TableCell
                  key={index}
                sx={{
                
                  fontWeight: 'medium',
                  fontSize:{ lg:'13px',sm:'0.8rem'},
                  padding: {lg:'0 10px' , xs:'0 2px'},
                  color: '#495161',
                  border:'none',
                  textAlign:'right'
                
                
              }}
                >
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>

            {
            Object.keys(rows)             
              .map((row_key,index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row_key}
                  sx={{
                    lineHeight: '60px',
                    position: 'relative',
                    transform: 'translateX(0)',
                
                    transition: 'all .3s ease',
                    border:'none',
                    boxShadow:'none',
                    background: '#FAFAFA'
                  }}>
                    {Object.keys(rows[row_key]).map((column,id) => {
                      const value = rows[row_key][column];
                     
                      return (
                        <TableCell key={id} 
                        sx={{
                          border:'none',
                          boxShadow:'none',
                          textAlign:'right',
                          fontSize:{sm:'0.7rem',lg:'0.87rem' ,xs :'0.5rem'},
                          
                          textOverflow:'ellipsis',
                          overflow:'hidden'
                        }}>
                          {value?
                          typeof(value) !== 'object' &&
                          value.toString().length > 12? getLanguage()==='en'?
                        value.toString().slice(0,11) + '...':
                        '...' +     value.toString().slice(0,11)
                        : value:''}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })

            }
          </TableBody>
        </Table>
        </PermissionBox>
      </TableContainer>
   
    </Paper>
  );
}
